module.exports = __webpack_public_path__ + "img/galeria-aquicultura-2.d3e2a9c3.jpg";